import React, { useState, useEffect } from "react";
import { db } from "./firebase";
import {
  collection,
  addDoc,
  getDocs,
  query,
  where,
  serverTimestamp,
} from "firebase/firestore";
import {
  Typography,
  Box,
  Button,
  TextField,
  Container,
} from "@mui/material";

const productsCollection = collection(db, "productos");
const leadsCollection = collection(db, "leads");

export default function AppPrelaunch() {
  const [step, setStep] = useState(1);
  const [productos, setProductos] = useState([]);
  const [correo, setCorreo] = useState("");
  const [seleccionado, setSeleccionado] = useState(null);
  const [contador, setContador] = useState(0);

  useEffect(() => {
    const fetchProducts = async () => {
      const q = query(productsCollection, where("status", "==", "activo"));
      const snapshot = await getDocs(q);

      const lista = snapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));

      setProductos(lista);
    };

    fetchProducts();
    fetchLeads();
  }, []);

  const fetchLeads = async () => {
    const snapshot = await getDocs(leadsCollection);
    setContador(snapshot.size);
  };

  const getProducto = (pos) =>
    productos.find((p) => p.posicionLanding === pos);

  const handleLeadSubmit = async () => {
    if (!correo.includes("@")) {
      alert("Ingresa un correo válido");
      return;
    }

    await addDoc(leadsCollection, {
      correo,
      productoSeleccionado: seleccionado,
      timestamp: serverTimestamp(),
    });

    await fetchLeads();

    alert("🔥 Te avisaremos antes que a nadie");

    setCorreo("");
    setSeleccionado(null);
    setStep(1);
  };

  // ---------------- PANTALLA 1 ----------------
  if (step === 1) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "#edb706",
          fontFamily: "Poppins, sans-serif", // 🔥 CAMBIO
          fontWeight: 600,
          color: "#ffffff",
        }}
      >
        <Container maxWidth={false} sx={{ px: 0 }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: {
                xs: "1fr",
                sm: "1fr 1fr",
              },
              gridTemplateRows: {
                xs: "auto",
                sm: "1fr auto 1fr",
              },
              gap: { xs: 2, sm: 2, md: 4 },
              alignItems: "center",
            }}
          >
            <ProductoCard p={getProducto("top_left")} seleccionado={seleccionado} setSeleccionado={setSeleccionado} />
            <ProductoCard p={getProducto("top_right")} seleccionado={seleccionado} setSeleccionado={setSeleccionado} />

            <Box
              sx={{
                gridColumn: { xs: "1", sm: "1 / span 2" },
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                py: { xs: 2, sm: 0 },
              }}
            >
              <img
                src="/images/logo.png"
                alt="logo"
                style={{
                  width: "260px",
                  maxWidth: "70%",
                }}
              />

              <Button
                onClick={() => {
                  if (!seleccionado) {
                    alert("Selecciona un producto");
                    return;
                  }
                  setStep(2);
                }}
                sx={{
                  mt: 2,
                  backgroundColor: "transparent",
                  color: "#ffffff",
                  border: "2px solid #ffffff",
                  borderRadius: "30px",
                  px: 5,
                  py: 1.5,
                  fontWeight: 700,
                  fontFamily: "Poppins, sans-serif", // 🔥 CAMBIO
                  "&:hover": {
                    backgroundColor: "#ffffff",
                    color: "#000000",
                  },
                }}
              >
                ORDENAR →
              </Button>
            </Box>

            <ProductoCard p={getProducto("bottom_left")} seleccionado={seleccionado} setSeleccionado={setSeleccionado} />
            <ProductoCard p={getProducto("bottom_right")} seleccionado={seleccionado} setSeleccionado={setSeleccionado} />
          </Box>
        </Container>
      </Box>
    );
  }

  // ---------------- PANTALLA 2 ----------------
  if (step === 2) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: "#edb706",
          fontFamily: "Poppins, sans-serif", // 🔥 CAMBIO
          fontWeight: 600,
          color: "#ffffff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          px: 3,
        }}
      >
        <img
          src="/images/mascota.png"
          alt="mascota"
          style={{
            width: "200px",
            marginBottom: "20px",
          }}
        />

        <Typography
          sx={{
            mb: 2,
            maxWidth: "340px",
            lineHeight: 1.6,
            fontSize: { xs: "15px", sm: "17px" },
            textAlign: "center",
            fontWeight: 400,
            fontFamily: "Poppins, sans-serif", // 🔥 CAMBIO
          }}
        >
          Tikki está por abrir sus puertas🔥 <br /><br />
          Tenemos un bowl GRATIS para los primeros 150 Tikki Fans 🎁   <br /><br />
          Déjanos tu correo y asegura el tuyo antes del lanzamiento 🚀
        </Typography>

        <Typography
          sx={{
            mb: 3,
            fontSize: "20px",
            fontWeight: 700,
            fontFamily: "Poppins, sans-serif", // 🔥 CAMBIO
          }}
        >
          Solo quedan {Math.max(0, 100 - contador)} Tikki Bowls
        </Typography>

        <TextField
          placeholder="Correo"
          value={correo}
          onChange={(e) => setCorreo(e.target.value)}
          size="small"
          sx={{
            backgroundColor: "#ffffff",
            borderRadius: "10px",
            width: "320px",
            mb: 2,
          }}
        />

        <Button
          onClick={handleLeadSubmit}
          sx={{
            backgroundColor: "transparent",
            color: "#ffffff",
            border: "2px solid #ffffff",
            borderRadius: "30px",
            px: 5,
            py: 1.5,
            fontWeight: 700,
            fontFamily: "Poppins, sans-serif", // 🔥 CAMBIO
            "&:hover": {
              backgroundColor: "#ffffff",
              color: "#000000",
            },
          }}
        >
          QUIERO TIKKI 🎁
        </Button>

        <Button
          onClick={() => setStep(1)}
          sx={{
            mt: 2,
            color: "#ffffff",
            fontWeight: 500,
            fontFamily: "Poppins, sans-serif", // 🔥 CAMBIO
          }}
        >
          ← Regresar
        </Button>
      </Box>
    );
  }

  return null;
}

// 🔥 PRODUCTO
function ProductoCard({ p, seleccionado, setSeleccionado }) {
  if (!p) {
    return <Box sx={{ height: { xs: "380px", sm: "300px", md: "340px" } }} />;
  }

  const isSelected = seleccionado === p.id;

  return (
    <Box
      onClick={() => setSeleccionado(p.id)}
      sx={{
        position: "relative",
        height: { xs: "380px", sm: "300px", md: "340px" },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        opacity: isSelected ? 1 : 0.85,
      }}
    >
      <img
        src={`/images/${p.imagen}`}
        alt={p.producto}
        style={{
          width: "120%",
          height: "120%",
          objectFit: "contain",
          filter: "drop-shadow(0px 14px 20px rgba(0,0,0,0.3))",
        }}
      />

      <Box
        sx={{
          position: "absolute",
          bottom: 16,
          display: "flex",
          alignItems: "center",
          gap: 1,
          backgroundColor: "rgba(0,0,0,0.6)",
          px: 2,
          py: 0.5,
          borderRadius: "20px",
        }}
      >
        <Box
          sx={{
            width: "14px",
            height: "14px",
            borderRadius: "50%",
            border: "2px solid #ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {isSelected && (
            <Box
              sx={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "#ffffff",
              }}
            />
          )}
        </Box>

        <Typography sx={{ fontSize: "13px", fontWeight: 600, fontFamily: "Poppins, sans-serif" }}>
          {p.producto}
        </Typography>
      </Box>
    </Box>
  );
}